<script setup lang="ts">
import { ref } from 'vue';
import { ButtonComp, type IInputPasswordModelValueType, type IInputPasswordPropsWithoutModelValue } from '@/components';
import InputTextBase from './InputTextBase.vue';

defineOptions({ inheritAttrs: false });

const props = withDefaults(defineProps<IInputPasswordPropsWithoutModelValue>(), {});

const value = defineModel<IInputPasswordModelValueType>({ required: true });

// If we have pressed the show password button
const passwordVisible = ref(false);

// Show the password for 5 seconds
const showPassword = () => {
    passwordVisible.value = true;

    setTimeout(() => {
        passwordVisible.value = false;
    }, 5000);
};
</script>
<template>
    <div>
        <label
            class="form-label textlabel"
            v-if="props.label"
            >{{ $tm(props.label) }}</label
        >
        <div class="input-group">
            <InputTextBase
                v-model="value"
                :type="passwordVisible ? 'text' : 'password'"
                :id="props.id ?? 'password'"
                v-bind="$attrs"
                :autofocus="props.autofocus"
                :disabled="props.disabled"
                :readonly="props.readonly"
                :placeholder="props.placeholder"
                :maxlength="props.maxlength"
                :icon="props.icon"
                :icon-family="props.iconFamily"
                :label="props.label"
                :selectOnFocus="props.selectOnFocus"
                :mark-text-part="props.markTextPart"
            />
            <span class="input-group-text-inline p-0">
                <!-- TODO: Should this skip the icon in the props since we already have an icon here -->
                <ButtonComp
                    icon="fa-eye"
                    buttonType="Secondary"
                    @click="showPassword"
                />
            </span>
        </div>
    </div>
</template>
